import React from 'react';
import classnames from 'classnames';
import { ChevronRightOutlinedIcon, ChevronLeftOutlinedIcon } from 'tuui';
import { FormButtons } from 'modules/campaigns/components';
import { FORM_MODES } from 'modules/campaigns/config';
import { StaticIndications } from 'modules/taboola-common-frontend-modules/Indications';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { usePublishedVersionNumber } from '../../../hooks/usePublishedVersionNumber';
import { Chat } from '../../Chat/Chat';
import { PreviewSection } from '../../PreviewSection/PreviewSection';
import styles from './chat.module.scss';

export const ChatStep = ({
    onCancel,
    onSubmit,
    onChatSubmit,
    onBack,
    mode = FORM_MODES.CREATE,
    containerClassName,
    className,
    cancelLabel,
}) => {
    const { value: slug } = useFormFieldValue({ field: 'slug' });
    const { value: versionNumber } = useFormFieldValue({ field: 'versionNumber' });
    const isCreate = mode === FORM_MODES.CREATE;

    const publishedVersionNumber = usePublishedVersionNumber();

    // Determine if current version is the published version
    const isPublishedVersion = publishedVersionNumber !== null && versionNumber === publishedVersionNumber;
    const canPublish = slug && !isPublishedVersion;

    return (
        <>
            <StaticIndications />
            <div className={classnames(styles['form-wrapper'], className)}>
                <div className={styles.container}>
                    <div className={styles['chat-container']}>
                        <Chat onSubmit={onChatSubmit} disabled={!slug} containerClassName={containerClassName} />
                    </div>
                    <PreviewSection
                        className={styles['preview-container']}
                        iframeClassName={styles['preview-frame']}
                        publishedVersionNumber={publishedVersionNumber}
                    />
                </div>
            </div>
            <div className={styles['buttons-wrapper']}>
                <FormButtons
                    className={styles['form-buttons']}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onBack={onBack}
                    disableSubmit={!canPublish}
                    backLabel={
                        !isCreate ? null : (
                            <>
                                <ChevronLeftOutlinedIcon />
                                <FormattedMessage id="landing.pages.form.edit.step.button.back" defaultMessage="Back" />
                            </>
                        )
                    }
                    submitLabel={
                        <FormattedMessage id="app.actionButtons.create.landing-page" defaultMessage="Publish" />
                    }
                    submitIcon={!isCreate ? null : <ChevronRightOutlinedIcon />}
                    submitDataMetricsComponent={!isCreate ? null : 'NextButton'}
                    cancelLabel={
                        cancelLabel || <FormattedMessage id="app.actionButtons.cancel" defaultMessage="Cancel" />
                    }
                />
            </div>
        </>
    );
};
